import { render } from "./details.vue?vue&type=template&id=3a553e49&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"

import "./details.vue?vue&type=style&index=0&id=3a553e49&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3a553e49"

export default script